import { Badge } from '@radix-ui/themes';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { Nullable } from 'lib_ts/interfaces/common/i-generics';
import { isNil } from 'lodash';
import { useMemo } from 'react';

export const VideoFrameRateBadge = (props: { value: Nullable<number> }) => {
  const color = useMemo(() => {
    if (isNil(props.value)) {
      return undefined;
    }

    if (props.value >= 59.94) {
      return RADIX.COLOR.SUCCESS;
    }

    if (props.value >= 24) {
      return RADIX.COLOR.WARNING;
    }

    return RADIX.COLOR.DANGER;
  }, [props.value]);

  if (isNil(props.value)) {
    return null;
  }

  return <Badge color={color}>{props.value} FPS</Badge>;
};
